import { api_suggested_ai_prompt_for_article_path, api_suggested_ai_prompts_path } from '@routes';

import request from './request';

export interface SuggestedAiPromptsResponse {
  suggestedAiPrompts: SuggestedAiPrompt[];
}

export interface ArticleSuggestedAiPromptResponse {
  suggestedAiPrompt: SuggestedAiPrompt;
}

export interface SuggestedAiPrompt {
  freePreview?: string;
  iconPngUrl: string;
  iconSvgUrl: string;
  prompt: string;
}

export async function getSuggestedAiPrompts(): Promise<SuggestedAiPromptsResponse> {
  const resp = await request('get', api_suggested_ai_prompts_path());
  return resp;
}

export async function getArticleSuggestedAiPrompt(): Promise<ArticleSuggestedAiPromptResponse> {
  const resp = await request('get', api_suggested_ai_prompt_for_article_path());
  return resp;
}
